//@flow

import React from "react"
import { FormattedMessage } from "react-intl"
import styled from "styled-components"
import { TweenMax, Cubic } from "gsap"
import {
  ForecastMetricContainerAlternate,
  ForecastMetricTitle,
  ForecastMetricSubtitle
} from "../UI"

import MetricLabel from "./MetricLabel"

import type { Metric } from "../../shared/AQILegend"

const Unit = styled.div`
  display: flex;
  border-left: 1px dashed #a2a5a7;
  padding-left: 2rem;
  margin-left: 0.5rem;
  color: #fff;
  text-transform: lowercase;
  font-size: 24px;
  font-family: "din-condensed";

  & > span {
    display: block;
    margin: auto;
  }
`

const Titles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 178px;
  flex-basis: 178px;
`

const ForecastMetricAltTitle = ForecastMetricTitle.extend`
  margin-top: auto;
  margin-bottom: 0;
`

const ForecastMetricAltSubtitle = ForecastMetricSubtitle.extend`
  margin-bottom: auto;
  margin-top: 0;
`
type Props = {
  pollutant: Metric,
  innerRef?: (el: HTMLElement) => any
}

class ForecastMetricAlternate extends React.Component<Props> {
  titles: Array<HTMLElement>

  constructor(props: Props) {
    super(props)
    this.titles = []
  }

  componentDidMount() {
    TweenMax.set(this.titles, { opacity: 0, x: "+=25" })
    TweenMax.staggerTo(
      this.titles,
      0.25,
      { opacity: 1, x: 0, ease: Cubic.easeOut, delay: 1 },
      0.2
    )
  }

  render() {
    const { pollutant, innerRef } = this.props

    return (
      <ForecastMetricContainerAlternate innerRef={innerRef}>
        <Titles>
          <ForecastMetricAltTitle innerRef={el => this.titles.push(el)}>
            <FormattedMessage id={`kiosk.forecast.metric.${pollutant}.name`} />
          </ForecastMetricAltTitle>
          <ForecastMetricAltSubtitle innerRef={el => this.titles.push(el)}>
            <FormattedMessage
              id={`kiosk.forecast.metric.${pollutant}.description`}
            />
          </ForecastMetricAltSubtitle>
        </Titles>
        <Unit innerRef={el => this.titles.push(el)}>
          <MetricLabel metric={pollutant} />
        </Unit>
      </ForecastMetricContainerAlternate>
    )
  }
}

export default ForecastMetricAlternate



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/ForecastMetric/ForecastMetricAlternate.js